function Main({ children }) {
  return <main className="row mt-5 pt- pb-3 text-bg-dark">{children}</main>;
}

export default Main;
